var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !(_vm.loaded === _vm.loadCount)
        ? _c("div", { style: _vm.style(), attrs: { id: "preloader" } }, [
            _vm._m(0)
          ])
        : _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sk-three-bounce" }, [
      _c("div", { staticClass: "sk-bounce-1 sk-child" }),
      _c("div", { staticClass: "sk-bounce-2 sk-child" }),
      _c("div", { staticClass: "sk-bounce-3 sk-child" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }